import { useState } from 'react'

import { Scheduled } from './Scheduled'

const STEPS = {
  SCHEDULED: 'scheduled',
  RESCHEDULE: 'reschedule',
}

export function StepContent() {
  const [step, setStep] = useState(STEPS.SCHEDULED)

  function handleReschedule() {
    setStep(STEPS.RESCHEDULE)
  }

  switch (step) {
    case STEPS.SCHEDULED:
      return <Scheduled onReschedule={handleReschedule} />
    case STEPS.RESCHEDULE:
      return <div>to be defined</div>
    default:
      return null
  }
}
